import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: '#1f1f1f',
    padding: theme.spacing(0.5),
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  clearAll: {
    color: '#fff',
  },
  title: {
    color: '#fff',
    textDecoration: 'none',
    fontWeight: 'bold',
  },
  logo: {
    flexGrow: 1,
    textAlign: 'left',
  },
  navLinks: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(4),
  },
  navLink: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    color: '#fff',
    transition: 'color 0.3s ease',
    '&:hover': {
      color: theme.palette.primary.light,
    },
  },
  navIcon: {
    color: '#4fc3f7',
    marginRight: theme.spacing(0.5),
    fontSize: '1.5rem',
  },
  linkText: {
    color: '#ffffff',
    fontSize: '1rem',
    fontWeight: 500,
  },
}));
